import Vue from 'vue'
import Element from 'element-ui'
import locale from 'element-ui/lib/locale/lang/vi'

Vue.use(Element, { locale })
